import React from 'react';
import { StoreLinkClickProps } from '../../types';
import { Store } from '../../../../types';
import * as S from './styles';

type OwnProps = {
  store: Store;
  storeLinkClick: (props: StoreLinkClickProps) => void;
};

const StoreLink = ({ store, storeLinkClick }: OwnProps) => {
  if (!store.externalUri) return null;

  const text = store.externalUriText?.split('/')[0];

  return (
    <S.StoreLink
      onClick={() =>
        storeLinkClick({
          id: store.id,
          name: store.name,
          featured: Boolean(store.featured),
          userReviewSummary: store.userReviewSummary,
        })
      }
      // eslint-disable-next-line react/jsx-no-target-blank
      target="_BLANK"
      rel="nofollow noopener"
      href={store.externalUri}
    >
      {text}
    </S.StoreLink>
  );
};

export default StoreLink;
